import type { IconData } from '@stacksjs/iconify-core'

export const envelopeF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M18.572.083L10.676 7.12a1 1 0 0 1-1.331 0L1.416.087A2 2 0 0 1 2 0h16a2 2 0 0 1 .572.083m1.356 1.385q.071.255.072.532v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 .072-.534l7.942 7.148a3 3 0 0 0 3.992 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default envelopeF
